module.exports = __webpack_public_path__ + "static/cfo-logo-70eabc3568a596678e3af086eba9c446.png";